export const SIZE_BUFFER = 10
export const SIZE_ARROW = 10
export const MAX_POSITION_ARROW = 20
export const POSITION_KEY = {
  TOP: 'top',
  BOTTOM: 'bottom',
  RIGHT: 'right',
  LEFT: 'left',
}
